import { createFileRoute } from "@tanstack/react-router";
import AdminPlansCatalog from "@/pages/admin/AdminPlansCatalog";

export const Route = createFileRoute("/admin/planes")({
  validateSearch: (search: Record<string, unknown>): { tab?: string | undefined } => ({
    tab: typeof search["tab"] === "string" ? (search["tab"] as string) : undefined,
  }),
  component: AdminPlansCatalog,
});
